import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50d1f8bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-wrap" }
const _hoisted_2 = { class: "w-full lg:w-3/5 space-y-6 py-2 px-4" }
const _hoisted_3 = { class: "w-full lg:w-2/5 space-y-6 px-4 relative" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "detail-title" }, "Raising funds to plant a forest", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-2 detail-info text-gray-500" }, " Highly sought after areas, handmade in small productions and blended to our highest standard using teas that are rarely (if ever) blended. Intense feeling, layered complexity and elegance. Set aside time for the experience. ", -1))
const _hoisted_6 = { class: "my-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-medium amount" }, "Amount", -1))
const _hoisted_8 = { class: "my-2 -mx-2 flex flex-wrap" }
const _hoisted_9 = ["onClick", "data-testid"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = { class: "my-2 flex w-auto items-center border border-gray-200 rounded-md overflow-hidden" }
const _hoisted_13 = { class: "w-24" }
const _hoisted_14 = { class: "my-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-medium summary-title" }, "Summary", -1))
const _hoisted_16 = { class: "my-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-200 my-6" }, null, -1))
const _hoisted_18 = { class: "my-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-medium payment-title" }, "Payment method", -1))
const _hoisted_20 = { class: "my-2" }
const _hoisted_21 = { class: "font-semibold" }
const _hoisted_22 = { class: "group space-y-4" }
const _hoisted_23 = { class: "w-full" }
const _hoisted_24 = { class: "text-xs text-red-700" }
const _hoisted_25 = { class: "flex space-x-4" }
const _hoisted_26 = { class: "w-full" }
const _hoisted_27 = { class: "text-xs text-red-700" }
const _hoisted_28 = { class: "w-full" }
const _hoisted_29 = { class: "text-xs text-red-700" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "absolute bottom-0 left-0 w-full h-12",
  type: "submit"
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-200 my-6" }, null, -1))
const _hoisted_32 = {
  key: 0,
  class: "my-2"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Email "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-red-700 text-sm" }, "*")
], -1))
const _hoisted_34 = {
  key: 0,
  class: "text-red-700 py-1"
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Donating ... ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Donate now ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Step process")
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "QR Code Payment", -1))
const _hoisted_39 = { class: "flex flex-col sm:flex-row overflow-hidden" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-8 sm:mx-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "border h-3/4" })
], -1))
const _hoisted_41 = { class: "overflow-hidden" }

import { computed, ref, watch, onMounted } from 'vue';
import { Icon } from '@iconify/vue';
import { Props as ButtonProps } from '../Base/BaseButton.vue';
import {
  ALLOWED_PAYMENT_CARD,
  ALLOWED_PAYMENT_CRYPTO,
  ALLOWED_PAYMENT_PAYPAL,
  STRIPE_PUBLIC_KEY,
} from '@/constants';
import useDonate from '@/composables/useDonate';
import DonateProgress from '../Donate/DonateProgress.vue';
import { useCardStore } from '@/store/card';
import { usePricesStore } from '@/store/prices';
import TransferReceipt from '../TransferReceipt.vue';
import PaymentQRCode from '../Payment/PaymentQRCode.vue';
import DonateSummary from './DonateSummary.vue';
import { DonateRequestType, DonateMethod } from '@/types/Donate';
import { useUserStore } from '@/store/user';
import useQRPayment from '@/composables/useQRPayment';
import { useToast } from 'vue-toastification';
import BaseChoices from '../Base/BaseChoices.vue';
import { useSmartContract } from '@/composables/useSmartContract';
import type { DonateQRCodeType } from '@/types/Donate';
import GalleryImage from '@/components/GalleryImage.vue';
import { useRouter } from 'vue-router';
import ProgressBar from '@/components/ProgressBar.vue';
import _ from 'lodash';
import { getAnalytics, logEvent } from 'firebase/analytics';

interface UsedButtonProps {
  outlined?: boolean;
  colorScheme?: ButtonProps['colorScheme'];
}

enum PaymentMethod {
  Crypto,
  Card,
  QRCode,
  Promptpay,
  Paypal,
}
interface PaymentOption {
  label: string;
  value: PaymentMethod;
  icon: string;
  allowed?: boolean;
  type?: DonateRequestType;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    outlined: { type: Boolean },
    colorScheme: { default: 'white' }
  },
  setup(__props: any) {



const router = useRouter();
const smartContract = useSmartContract();
const toast = useToast();
const card = useCardStore();
const user = useUserStore();
const loadingElStripe = ref(true);
const email = ref<string>('');
const emailError = ref<string>('');
const {
  amount: contracts,
  donate,
  recipient,
  isDonating,
  usdtProgress,
} = useDonate({
  initialAmount: 1,
  onAfterConfirmed: () => {
    card.clearCard();
    selectedPayment.value = 0;
  },
});
const isQRPaymentActive = ref(false);
const analytics = getAnalytics();

const onPromptPayPaid = () => {
  toast.success('Your donation has been completed');
  isQRPaymentActive.value = false;
  // isModalActive.value = false;
  contracts.value = 1;
};
const { createQRPayment, qrPayment, stopQRScan } = useQRPayment({
  onPaid: onPromptPayPaid,
});
const donateWithQRPayment = (type: DonateQRCodeType) => {
  isQRPaymentActive.value = true;
  createQRPayment({
    type,
    amount: contracts.value as number,
    receiver: email.value as string,
  });
};
const donateWithPaypal = async () => {
  isDonating.value = true;
  const res = await createQRPayment({
    type: DonateMethod.paypal,
    amount: contracts.value as number,
    receiver: email.value as string,
  });
  window.location.assign(res?.paymentUrl as string);
  setTimeout(() => {
    isDonating.value = false;
  }, 1000);
};

const donateWithCard = _.debounce((token: any) => {
  if (
    card.error.number === '' ||
    card.error.expiration === '' ||
    card.error.cvv === '' ||
    card.error.name === '' ||
    emailError.value === ''
  ) {
    if (token) {
      let e = '';
      if (!user.isLoggedIn) {
        e = email.value;
      } else {
        e = user.me?.getEmail() as string;
      }
      donate(
        e,
        'fiat',
        activePaymentOption.value.symbol,
        token.paymentMethod.id
      );
    }
  }
}, 1000);
onMounted(() => {
  logEvent(analytics, 'donate_visit');
  if (isMetamaskInstalled.value) {
    logEvent(analytics, 'donate_metamask_installed');
  } else {
    logEvent(analytics, 'donate__metamask_not_installed');
  }
  if (user.isGeneratedUser) {
    logEvent(analytics, 'donate_user_generated');
  } else {
    logEvent(analytics, 'donate_user_not_generated');
  }
  if (!user.isGeneratedUser && isMetamaskInstalled.value) {
    paymentMethod.value = PaymentMethod.Crypto;
  } else {
    paymentMethod.value = PaymentMethod.Card;
    useStripe();
  }
});
const isMetamaskInstalled = computed(() => {
  if (typeof window.ethereum !== 'undefined') {
    return true;
  } else {
    return false;
  }
});

const setEmailDonate = () => {
  let e = '';
  if (!user.isLoggedIn) {
    e = email.value;
  } else {
    e = user.me?.getEmail() as string;
  }
  localStorage.setItem('donate_email', e);
};
const handleDonate = async () => {
  logEvent(analytics, 'donate_handle');

  const donateMethod = paymentMethodOptions.find(
    (m) => m.value === paymentMethod.value
  );

  // validate card
  card.clearCard();
  // check email
  emailError.value = '';
  if (!user.isLoggedIn) {
    if (email.value === '') {
      emailError.value = 'Required';
      const emailInput = document.getElementById('emailInput') as HTMLElement;
      (emailInput.children[0] as HTMLElement).focus();
      return;
    }
    if (!emailError.value && !/\S+@\S+\.\S+/.test(email.value)) {
      emailError.value = 'Invalid email address.';
      const emailInput = document.getElementById('emailInput') as HTMLElement;
      (emailInput.children[0] as HTMLElement).focus();
      return;
    }
  }

  setEmailDonate();
  const e = localStorage.getItem('donate_email') as string;
  switch (donateMethod?.value) {
    // use stripe element
    case PaymentMethod.Card:
      logEvent(analytics, 'donate_select_card');
      useStripe();
      break;
    case PaymentMethod.Crypto: {
      logEvent(analytics, 'donate_select_crypto');
      const payment = activePaymentOption.value;
      payment && donate(e, payment.symbol.toLowerCase() as string);
      break;
    }
    case PaymentMethod.Promptpay:
      logEvent(analytics, 'donate_select_promtpay');
      donateWithQRPayment(DonateMethod.promptpay);
      break;
    case PaymentMethod.QRCode: {
      logEvent(analytics, 'donate_select_scbrq30');
      donateWithQRPayment('scbqr30');
      break;
    }
    case PaymentMethod.Paypal: {
      logEvent(analytics, 'donate_select_paypal');
      donateWithPaypal();
      break;
    }
    default:
      break;
  }
};

const paymentMethodOptions: PaymentOption[] = [
  {
    label: 'MetaMask',
    value: PaymentMethod.Crypto,
    icon: 'logos:metamask-icon',
    allowed:
      user.isGeneratedUser || !isMetamaskInstalled.value
        ? false
        : ALLOWED_PAYMENT_CRYPTO,
  },
  {
    label: 'Credit / Debit card',
    value: PaymentMethod.Card,
    icon: 'bi:credit-card',
    allowed: ALLOWED_PAYMENT_CARD,
    type: DonateMethod.credit,
  },
  // {
  //   label: 'QR Code (PromptPay)',
  //   value: PaymentMethod.Promptpay,
  //   icon: 'ic:round-qr-code-scanner',
  //   allowed: ALLOWED_PAYMENT_QRCODE,
  //   type: 'promptpay',
  // },
  // {
  //   label: 'QR Code',
  //   value: PaymentMethod.QRCode,
  //   icon: 'bi:qr-code-scan',
  //   allowed: ALLOWED_PAYMENT_QRCODE,
  //   type: 'scbqr30',
  // },

  {
    label: 'Paypal',
    value: PaymentMethod.Paypal,
    icon: 'logos:paypal',
    allowed: ALLOWED_PAYMENT_PAYPAL,
    type: DonateMethod.paypal,
  },
];
const paymentMethod = ref<PaymentMethod>(
  !user.isLoggedIn ? PaymentMethod.Card : PaymentMethod.Crypto
);

const useStripe = () => {
  setTimeout(() => {
    loadingElStripe.value = true;
    const stripe = (window as any).Stripe(STRIPE_PUBLIC_KEY, {
      locale: 'en',
    });
    const elements = stripe.elements();
    const style = {
      base: {
        iconColor: '#666EE8',
        color: '#676767',
        lineHeight: '40px',
        fontWeight: 400,
        fontSize: '16px',
        '::placeholder': {
          color: '#676767',
        },
      },
    };
    // clear data
    card.form.name = '';
    card.error.number = '';
    card.error.expiration = '';
    card.error.cvv = '';
    card.error.name = '';
    emailError.value = '';

    const cardNumberElement = elements.create('cardNumber', {
      style: style,
      placeholder: 'Card Number',
    });

    cardNumberElement.mount('#card-number-element');
    cardNumberElement.on('change', function () {
      card.error.number = '';
    });

    const cardExpiryElement = elements.create('cardExpiry', {
      style: style,
      placeholder: 'Expiry date',
    });
    cardExpiryElement.mount('#card-expiry-element');
    cardExpiryElement.on('change', function () {
      card.error.expiration = '';
    });

    const cardCvcElement = elements.create('cardCvc', {
      style: style,
      placeholder: 'CVV',
    });
    cardCvcElement.mount('#card-cvc-element');
    cardCvcElement.on('change', function () {
      card.error.cvv = '';
    });

    const cardNameInput = document.getElementById(
      'cardNameInput'
    ) as HTMLElement;

    cardNameInput.addEventListener('keypress', (event) => {
      const inputValue = event.charCode;
      card.error.name = '';

      if (
        !(inputValue >= 65 && inputValue <= 120) &&
        inputValue != 32 &&
        inputValue != 0
      ) {
        event.preventDefault();
      }
    });

    cardCvcElement.on('ready', function () {
      loadingElStripe.value = false;
    });

    //click submit donate
    document?.querySelector('form')?.addEventListener('submit', function (e) {
      e.preventDefault();

      setEmailDonate();

      // check email
      emailError.value = '';
      if (!user.isLoggedIn) {
        if (email.value.length < 1) {
          emailError.value = 'Required';
        }
        if (!emailError.value && !/\S+@\S+\.\S+/.test(email.value)) {
          emailError.value = 'Invalid email address.';
        }
      }

      if (!card.form.name) {
        card.error.name = 'Required';
      } else {
        card.error.name = '';
      }

      //cardCvcElement
      if (cardCvcElement._empty) {
        card.error.cvv = 'Required';
        cardCvcElement.focus();
      } else if (!cardCvcElement._complete) {
        card.error.cvv = 'Invalid';
        cardCvcElement.focus();
      } else {
        card.error.cvv = '';
      }

      // cardExpiryElement
      if (cardExpiryElement._empty) {
        card.error.expiration = 'Required';
        cardExpiryElement.focus();
      } else if (!cardExpiryElement._complete) {
        card.error.expiration = 'Invalid';
        cardExpiryElement.focus();
      } else {
        card.error.expiration = '';
      }

      //cardNumberElement
      if (cardNumberElement._empty) {
        card.error.number = 'Required';
        cardNumberElement.focus();
      } else if (!cardNumberElement._complete) {
        card.error.number = 'Invalid';
        cardNumberElement.focus();
      } else {
        card.error.number = '';
      }

      if (card.error.name != '') {
        (cardNameInput.children[0] as HTMLElement).focus();
      }
      if (
        card.error.number == '' &&
        card.error.expiration == '' &&
        card.error.cvv == '' &&
        card.error.name == '' &&
        emailError.value == '' &&
        !cardNumberElement._empty &&
        !cardExpiryElement._empty &&
        !cardCvcElement._empty &&
        card.form.name != ''
      ) {
        stripe.createToken(cardNumberElement).then((res: any) => {
          stripe
            .createPaymentMethod({
              type: 'card',
              card: { token: res.token.id },
              billing_details: {
                name: card.form.name,
              },
            })
            .then(function (result: any) {
              donateWithCard(result);
            });
        });
      }
    });
  }, 1);
};

const onPaymentMethod = async (value: PaymentMethod) => {
  // if (value === PaymentMethod.Crypto && isMetamaskInstalled.value) {
  //   await user.connectWallet();
  // }
  // card.clearCard();
  logEvent(analytics, `select_method_${PaymentMethod[value]}`);

  if (
    value === PaymentMethod.Card &&
    paymentMethod.value !== PaymentMethod.Card
  ) {
    useStripe();
  }
  paymentMethod.value = value;
};

const activePaymentMethod = computed(() =>
  paymentMethodOptions.find((item) => item.value === paymentMethod.value)
);
const isFiat = computed(() => paymentMethod.value !== PaymentMethod.Crypto);
const prices = usePricesStore();
watch(
  [activePaymentMethod, () => smartContract.aggregator],
  async ([paymentValue]) => {
    // if (aggregator) prices.getCryptosEnabled(aggregator);
    if (paymentValue) {
      if (paymentValue.value === PaymentMethod.Crypto) {
        prices.getCryptoPrices();
      } else {
        await prices.getPrices(paymentValue.type as DonateRequestType);

        // default by time zone th
        const now = new Date();
        const indexOfTHB = prices.items.map((e) => e.symbol).indexOf('THB');
        if (indexOfTHB > -1 && now.getTimezoneOffset() == -420)
          selectedPayment.value = 0;
      }
    }
  },
  { immediate: true }
);

const payments = computed(() => {
  switch (paymentMethod.value) {
    case PaymentMethod.Crypto:
      return prices.cryptos;
    default: {
      return prices.items;
    }
  }
});
const selectedPayment = ref(0);
const activePaymentOption = computed(
  () => payments.value[selectedPayment.value]
);

const contractsChange = (c: number) => {
  const a = (contracts.value as number) + c;
  if (a < 1) {
    contracts.value = 1;
  } else {
    contracts.value = a;
  }
};
const selectedContracts = (c: number) => {
  contracts.value = c;
  if (paymentMethod.value === 4) {
    createQRPayment({
      type: DonateMethod.paypal,
      amount: contracts.value as number,
      receiver: recipient.value as string,
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_BaseLoading = _resolveComponent("BaseLoading")!
  const _component_BaseInputText = _resolveComponent("BaseInputText")!
  const _component_BaseFormField = _resolveComponent("BaseFormField")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(isDonating))
      ? (_openBlock(), _createBlock(_component_BaseLoading, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ProgressBar, { goal: "weekly" }),
        _createVNode(GalleryImage, { images: [
            '/images/donates/donate-1.png',
            '/images/donates/donate-2.png',
            '/images/donates/donate-3.png',
            '/images/donates/donate-4.png',
            '/images/donates/donate-5.png',
          ] }, null, 8, ["images"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([5, 10, 15, 20], (a) => {
                return _createElementVNode("div", {
                  key: `amount-${a}`,
                  class: _normalizeClass(["border border-gray-100 rounded-md px-4 py-1 text-gray-600 mx-1 my-1 cursor-pointer amount", {
                  'border-primary bg-primary bg-opacity-10 text-primary':
                    a == _unref(contracts),
                }]),
                  onClick: ($event: any) => (selectedContracts(a)),
                  "data-testid": `donate-select-contracts-${a}`
                }, [
                  _createTextVNode(_toDisplayString(a) + " ft", 1),
                  _hoisted_10
                ], 10, _hoisted_9)
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: "w-9 h-9 text-gray-600 bg-gray-50 border-r border-gray-200 font-semibold cursor-pointer flex justify-center items-center",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (contractsChange(-1))),
                  "data-testid": "donate-contracts-minus"
                }, " - "),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "py-0 px-0 text-center w-full amount-input",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(contracts) ? (contracts).value = $event : null))
                  }, null, 512), [
                    [_vModelText, _unref(contracts)]
                  ])
                ]),
                _createElementVNode("div", {
                  class: "w-9 h-9 text-gray-600 bg-gray-50 border-l border-gray-200 font-semibold cursor-pointer flex justify-center items-center",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (contractsChange(1))),
                  "data-testid": "donate-contracts-plus"
                }, " + ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createVNode(DonateSummary, {
                payment: selectedPayment.value,
                "onUpdate:payment": _cache[3] || (_cache[3] = ($event: any) => ((selectedPayment).value = $event)),
                amount: _unref(contracts),
                payments: _unref(payments)
              }, null, 8, ["payment", "amount", "payments"])
            ])
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(BaseChoices, {
                "model-value": paymentMethod.value,
                choices: paymentMethodOptions,
                vertical: "",
                "onUpdate:modelValue": onPaymentMethod
              }, {
                default: _withCtx(({ label, index }) => [
                  _createVNode(_unref(Icon), {
                    icon: paymentMethodOptions[index].icon,
                    width: "26",
                    height: "26",
                    class: "mr-4"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(label), 1)
                ]),
                content: _withCtx(({ index }) => [
                  (index === PaymentMethod.Card)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["w-full my-4 pl-8 h-0", { 'h-auto': !loadingElStripe.value }])
                      }, [
                        _withDirectives(_createElementVNode("form", null, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("label", _hoisted_23, [
                              _createElementVNode("div", {
                                id: "card-number-element",
                                class: _normalizeClass(["field pl-4", { error: _unref(card).error.number !== '' }])
                              }, null, 2),
                              _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(card).error.number), 1)
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("label", _hoisted_26, [
                                _createElementVNode("div", {
                                  id: "card-expiry-element",
                                  class: _normalizeClass(["field pl-4", { error: _unref(card).error.expiration !== '' }])
                                }, null, 2),
                                _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(card).error.expiration), 1)
                              ]),
                              _createElementVNode("label", _hoisted_28, [
                                _createElementVNode("div", {
                                  id: "card-cvc-element",
                                  class: _normalizeClass(["field pl-4", { error: _unref(card).error.cvv !== '' }])
                                }, null, 2),
                                _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(card).error.cvv), 1)
                              ])
                            ]),
                            _createVNode(_component_BaseFormField, {
                              label: "",
                              error: _unref(card).error.name
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_BaseInputText, {
                                  id: "cardNameInput",
                                  modelValue: _unref(card).form.name,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(card).form.name) = $event)),
                                  placeholder: "Cardholder name",
                                  error: _unref(card).error.name !== '',
                                  "data-testid": "donate-card-name",
                                  class: "card-name"
                                }, null, 8, ["modelValue", "error"])
                              ]),
                              _: 1
                            }, 8, ["error"])
                          ]),
                          _hoisted_30
                        ], 512), [
                          [_vShow, !loadingElStripe.value]
                        ])
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model-value"])
            ])
          ]),
          _hoisted_31,
          (!_unref(user).isLoggedIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", null, [
                  _createVNode(_component_BaseInputText, {
                    id: "emailInput",
                    placeholder: "example@hotmail.com",
                    error: !!emailError.value,
                    modelValue: email.value,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => ((email).value = $event)),
                      _cache[6] || (_cache[6] = ($event: any) => (emailError.value = ''))
                    ],
                    "data-testid": "donate-email-guest"
                  }, null, 8, ["error", "modelValue"]),
                  (emailError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(emailError.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(activePaymentOption))
          ? (_openBlock(), _createBlock(TransferReceipt, {
              key: 0,
              "price-for": "contract",
              price: _unref(activePaymentOption).pricePerContract,
              symbol: _unref(activePaymentOption).symbol,
              amount: _unref(contracts),
              "is-fiat": _unref(isFiat)
            }, null, 8, ["price", "symbol", "amount", "is-fiat"]))
          : _createCommentVNode("", true),
        (_unref(isDonating))
          ? (_openBlock(), _createBlock(_component_BaseButton, {
              key: 1,
              disabled: true,
              full: ""
            }, {
              default: _withCtx(() => [
                _hoisted_35
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_BaseButton, {
              key: 2,
              "color-scheme": "primary",
              full: "",
              disabled: !_unref(contracts),
              onClick: handleDonate,
              "data-testid": "donate-handle"
            }, {
              default: _withCtx(() => [
                _hoisted_36
              ]),
              _: 1
            }, 8, ["disabled"]))
      ])
    ]),
    _createVNode(_component_BaseModal, {
      modelValue: _unref(usdtProgress).active,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(usdtProgress).active) = $event)),
      onClosed: _cache[9] || (_cache[9] = ($event: any) => {
        _unref(usdtProgress).current = 0;
        _unref(usdtProgress).loading = false;
      })
    }, {
      title: _withCtx(() => [
        _hoisted_37
      ]),
      default: _withCtx(() => [
        _createVNode(DonateProgress, {
          current: _unref(usdtProgress).current,
          loading: _unref(usdtProgress).loading,
          onConfirm: _cache[7] || (_cache[7] = ($event: any) => {
          _unref(usdtProgress).active = false;
          _unref(router).push('/app/activity');
        })
        }, null, 8, ["current", "loading"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_BaseModal, {
      modelValue: isQRPaymentActive.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((isQRPaymentActive).value = $event)),
      onClosed: _unref(stopQRScan)
    }, {
      title: _withCtx(() => [
        _hoisted_38
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_39, [
          _createVNode(PaymentQRCode, {
            class: "mb-2 flex-shrink-0",
            "qr-code": _unref(qrPayment)?.image,
            onReset: _cache[10] || (_cache[10] = ($event: any) => (_unref(createQRPayment)({   
            amount: (_unref(contracts).value as number),
            receiver: email.value as string,
            type: _unref(activePaymentMethod)?.type as DonateQRCodeType
            })))
          }, null, 8, ["qr-code"]),
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            (_unref(activePaymentOption))
              ? (_openBlock(), _createBlock(TransferReceipt, {
                  key: 0,
                  class: "mt-6",
                  "price-for": "contract",
                  price: _unref(activePaymentOption).pricePerContract,
                  symbol: _unref(activePaymentOption).symbol,
                  amount: _unref(contracts),
                  "is-fiat": _unref(isFiat)
                }, null, 8, ["price", "symbol", "amount", "is-fiat"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClosed"])
  ]))
}
}

})